import { create } from 'zustand'
import { apiService } from '@/services/api'

/**
 * 인수인계 미확인 수 — 헤더 알림바 + 사이드바 배지용.
 * pending-counts(WS)와 별개로 가벼운 REST 폴링. 페이지에서 글 작성/확인 시 즉시 refresh.
 */
interface HandoverUnreadStore {
  count: number
  refresh: () => Promise<void>
}

export const useHandoverUnreadStore = create<HandoverUnreadStore>((set) => ({
  count: 0,
  refresh: async () => {
    try {
      const res: any = await apiService.get('/api/v1/admin/handover/unread-count')
      set({ count: Number(res?.count || 0) })
    } catch { /* 무시 */ }
  },
}))
